import {ChangeDetectorRef, Component, OnInit} from '@angular/core';

import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {BREADCRUMB_MAP, PageInfo} from '../../../core/models/breadcrumbs';
import {ACTIVE_PAGE_KEY} from '@shared/constants/storage-keys';


@Component({
    selector: 'app-breadcrumb-card',
    imports: [
        RouterLink
    ],
    templateUrl: './breadcrumb-card.component.html',
    styleUrl: './breadcrumb-card.component.css'
})
export class BreadcrumbCardComponent implements OnInit {
    activePage: PageInfo = {
        breadcrumb: [{label: 'Início', iconComponent: 'home', route: '/'}],
        title: 'Início',
        route: '/',
    };
    activeRoute: string = '/';
    breadcrumbMap: { [route: string]: PageInfo } = BREADCRUMB_MAP;

    constructor(
        private readonly router: Router,
        private readonly cdr: ChangeDetectorRef,
    ) {

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.updateActivePage(event.urlAfterRedirects);
            }
        });
    }

    ngOnInit(): void {
        this.cdr.detectChanges();

        const savedPage = localStorage.getItem(ACTIVE_PAGE_KEY);
        if (savedPage) {
            this.activePage = JSON.parse(savedPage);
        } else {
            this.activePage = this.breadcrumbMap['/'];
        }

        this.updateActivePage(this.router.url);
    }

    updateActivePage(url: string) {
        const normalizedUrl = url.split('?')[0].split('#')[0];

        if (this.breadcrumbMap[normalizedUrl]) {
            this.activePage = this.breadcrumbMap[normalizedUrl];
            this.activeRoute = normalizedUrl;
        } else {
            this.activePage = this.breadcrumbMap['/'];
            this.activeRoute = '/';
        }

        localStorage.setItem(ACTIVE_PAGE_KEY, JSON.stringify(this.activePage));
    }

}
